export const DATA_LIST_OPTION = "data-list-option";
export const DATA_LIST_OPTION_HOVERED = "data-list-option-hovered";
export const DATA_LIST_OPTION_SELECTED = "data-list-option-selected";

export enum AllowedKeyCode {
  Enter = "Enter",
  ArrowDown = "ArrowDown",
  ArrowUp = "ArrowUp",
}

export type HighlightDirection = "up" | "down";
export type GetNextIdFunc = (
  curElemId: number,
  direction: HighlightDirection
) => { nextId: number; isOverflow: boolean };

export type OnEnterSubmitFunc = (curElemId: number) => void;
